import React, { useState } from 'react'

const EmployeesLogsNew = () => {
  return <div>EmployeesLogsNew</div>
}

export default EmployeesLogsNew
